module.exports = __webpack_public_path__ + "img/m_menu.dd6aeef7.svg";